
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m18.107 9.75-4.383-4.572a2.6 2.6 0 0 1-.486-2.994h0a2.593 2.593 0 0 1 4.153-.674l.716.716.716-.716a2.593 2.593 0 0 1 4.153.674h0a2.594 2.594 0 0 1-.486 2.994ZM7.5 10.125a.375.375 0 0 1 .375.375m-.75 0a.375.375 0 0 1 .375-.375m0 .75a.375.375 0 0 1-.375-.375m.75 0a.375.375 0 0 1-.375.375m-1.489 9.329L5.25 23.25m11.24-3.042.76 3.042","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9.019 5.516 7.054 3.879a.749.749 0 0 0-1.224.483l-.351 2.811A8.206 8.206 0 0 0 2.6 11.25H.75v6h2.49a9.114 9.114 0 0 0 8.01 4.5c4.971 0 9-3.694 9-8.25a7.444 7.444 0 0 0-.037-.75","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    